module.exports = __webpack_public_path__ + "img/hr-puberty-decal-28.f94191df.png";